// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'
import { SubmitErrors } from 'components/Form'
import { CALLSIGN_CASCADE_FORM } from './constants'
import FieldArrayWrapper from './FieldArrayWrapper'

import {
  FieldArray,
  reduxForm,
} from 'redux-form'

const Form = props => {
  const {
    callsignCascadeData,
    closeModal,
    error,
    form,
    handleSubmit,
  } = props

  return (
    <form onSubmit={handleSubmit}>
      <SubmitErrors
        error={error}
        idRoot={form}
        sourceForm={form} />
      <div
        className={'padding-1 overflow-hidden display-flex flex-direction-column'}
        style={{ maxHeight: '80vh' }}>
        <p id={`${form}-heading-message`}>
          <span>
            {'Please select the site(s) below to cascade changes to the following fields: '}
          </span>
          <strong className={'text-blue-dark'}>
            {'Site Name, Call Sign, Contact Code, Latitude, Longitude, Ground Elevation, ASR.'}
          </strong>
        </p>
        <FieldArray
          callsignCascadeData={callsignCascadeData}
          component={FieldArrayWrapper}
          idRoot={`${form}-callsignCascadeInput`}
          name={'callsignCascadeInput'} />
        <div className={'display-flex justify-content-center'}>
          <button
            className={'btn btn-md bg-green hover-inverse heading-font margin-right-1'}
            id={`${form}-submit`}
            type={'submit'}>
            {'Continue'}
          </button>
          <button
            className={'btn btn-md bg-grey-dark hover-inverse heading-font margin-left-1'}
            id={`${form}-cancel`}
            onClick={closeModal}
            type={'button'}>
            {'Cancel'}
          </button>
        </div>
      </div>
    </form>
  )
}

Form.propTypes = {
  callsignCascadeData: array.isRequired,
  closeModal: func.isRequired,
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
}

export default reduxForm({
  form: CALLSIGN_CASCADE_FORM,
})(Form)
